// removed by extract-text-webpack-plugin
module.exports = {"colorSelect":"_1SXAm_1AQNA0vkMN68GXzq","colorValueContainer":"_3s-hSb7Jb469TotBIi-1bu","colorOption":"_2ptVZOGlkYJEiMBdDHPXuH","colorValue":"_3-CNgRDoAhDlKpqCoiV39Y","colorValueTodo":"_3w6itoHmAT40jUI0wpJpBa"};


//////////////////
// WEBPACK FOOTER
// ./components/shared/select/ColorSelectWrapper.scss
// module id = 1625
// module chunks = 0